(() => {
  const root = document.documentElement;
  const sync = () => {
    const active = root.dataset.salesEnabled === 'true';
    const value = String(active);
    if (root.dataset.shippingPromo !== value) {
      root.dataset.shippingPromo = value;
      document.dispatchEvent(new CustomEvent('hiverane:shipping-promo', { detail: { active } }));
    }
  };
  sync();
  document.addEventListener('visibilitychange', sync);
  window.addEventListener('pageshow', sync);
})();
